import type { ReadonlySignal } from "@preact/signals";
import * as preact from "preact";

import stores from "stores/stores";
import * as tts from "tts";
import * as speakingModeControls from "views/speakingModeControls";

interface Props {
  onClick?: () => void;
  onSpeak?: () => void;
  title?: string;
  /**
   * Whether a sound can start yet: in the Web Reader extension only after a
   * click in it. Until then it shows off, and a click (which lets sound start)
   * turns it on.
   */
  canPlay?: ReadonlySignal<boolean>;
}

class ToggleSpeakingModeView extends preact.Component<Props> {
  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
      return;
    }

    if (stores.user.speakingMode.value && !this.isOn()) {
      this.props.onSpeak?.();
      return;
    }
    speakingModeControls.setSpeakingModeWithVoicePrompt(
      !this.isOn(),
      stores.user.currentLearningLanguage.value,
      this.props.onSpeak
    );
  };

  isOn = () =>
    stores.user.speakingMode.value && (this.props.canPlay?.value ?? true);

  render() {
    const language = stores.user.currentLearningLanguage.value!;
    const languageSupported =
      tts.getAvailabilitySignal({
        user: stores.user,
        feature: "speakingMode",
        language,
      }).value === "supported";
    if (!languageSupported) return null;

    const on = this.isOn();
    const title =
      this.props.title ??
      (on
        ? "Click to turn off Auto-Pronounce"
        : "Click to turn on Auto-Pronounce");

    return (
      <span title={title} onClick={this.handleClick}>
        {on ? (
          <i class="icon-volume-up" />
        ) : (
          <>
            <i class="icon-volume-off" />
            <i style="font-size:50%;margin-left:1px" class="icon-remove" />
          </>
        )}
      </span>
    );
  }
}

export default ToggleSpeakingModeView;
